import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

const API_URL = '/cargo/open-api/currency-rates';
const FALLBACK: Record<string, number> = { USD: 501, EUR: 597, CNY: 72 };
const INTERVAL_MS = 60 * 60 * 1000;

export type CurrencyRates = Record<string, number>;

@Injectable({
  providedIn: 'root',
})
export class CurrencyRatesService {
  private rates$ = new BehaviorSubject<CurrencyRates>({ ...FALLBACK });
  private intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(private http: HttpClient) {}

  getRates() {
    return this.rates$.asObservable();
  }

  start(): void {
    this.fetch();
    if (!this.intervalId) {
      this.intervalId = setInterval(() => this.fetch(), INTERVAL_MS);
    }
  }

  stop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private fetch(): void {
    this.http.get<Record<string, number>>(API_URL).subscribe({
      next: (res) => {
        if (res && typeof res === 'object' && (res['USD'] || res['EUR'] || res['CNY'])) {
          this.rates$.next({
            USD: res['USD'] ?? FALLBACK['USD'],
            EUR: res['EUR'] ?? FALLBACK['EUR'],
            CNY: res['CNY'] ?? FALLBACK['CNY'],
          });
        }
      },
      error: (err) => { console.warn('CurrencyRates: fetch failed', err?.status ?? err); },
    });
  }
}
